import type { IAccessPopulated, IIssueBoardApi } from "@mcapps/shared";
import React from "react";
import { FailedAlert } from "../../../../components"; // reuse existing alert for consistency
import { AccessComp } from "../../../../components/AccessComp/AccessComp";
import { useAppSelector } from "../../../../hooks";
import { usePutProjectByProjectIdIssueboardAndBoardIdAccessMutation } from "../../../../../openapi";
import SettingsCardWrapper from "./SettingsCardWrapper";

const IssueAccessSettings: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [updateAccess, { error: updateAccessError }] = usePutProjectByProjectIdIssueboardAndBoardIdAccessMutation();

  const members = useAppSelector((state) => state.adminReducer.project.members);

  const users = members.reduce((acc, member) => {
    if (member.user != null) {
      acc.push(member.user);
    }
    return acc;
  }, []);

  const [editMode, setEditMode] = React.useState(false);
  return (
    <SettingsCardWrapper title="Tilgangsstyring">
      {updateAccessError != null && <FailedAlert />}
      <AccessComp
        access={issueBoard.access as IAccessPopulated}
        isEditable
        variant="md"
        fontSize="1.1em"
        updateAccess={(access) =>
          updateAccess({
            projectId: issueBoard.project,
            boardId: issueBoard._id,
            body: {
              access: {
                level: access.level,
                groups: access.groups,
                users: access.users.map((user) => user._id),
              },
            },
          })
        }
        editMode={editMode}
        allUsers={users}
        editCb={(bool) => setEditMode(bool)}
      />
    </SettingsCardWrapper>
  );
};

export default IssueAccessSettings;
